import * as types from '../actionTypes/NotificationDetailsActionTypes';

function NotificationReducer(state = {}, action = {}) {
    switch (action.type) {
        case types.GET_NOTIFICATION:
        case types.UPDATE_NOTIFICATION: {
            const isLoading = true;
            const isSuccess = false;
            const requestFrom = null;
            return { ...state, isLoading, isSuccess, requestFrom };
        }

        case types.GET_NOTIFICATION_SUCCESS: {
            const { isLoading, response, isSuccess, requestFrom } = action.notificationPayload
                ? action.notificationPayload
                : action.payload;
            return { ...state, isLoading, isSuccess, response, requestFrom };
        }

        case types.GET_NOTIFICATION_ERROR: {
            const { isLoading, error, isSuccess, requestFrom } = action.payload;
            return { ...state, isLoading, isSuccess, requestFrom, error };
        }

        case types.UPDATE_NOTIFICATION_SUCCESS: {
            const { isLoading, response, isSuccess, requestFrom } = action.payload;
            return { ...state, isLoading, isSuccess, requestFrom, response };
        }
        case types.UPDATE_NOTIFICATION_ERROR: {
            const { isLoading, error, isSuccess, requestFrom } = action.payload;
            return { ...state, isLoading, isSuccess, requestFrom, error };
        }

        default:
            return state;
    }
}

NotificationReducer.reducerName = 'notificationDetails';
export default NotificationReducer;
